export const CHANGE_ENABLE_MAP = "map/CHANGE_ENABLE_MAP";
export const HANDLE_MENU_CONTEXT_STYLE = "map/HANDLE_MENU_CONTEXT_STYLE";
export const UPDATE_LAST_USER_POSITION = "map/UPDATE_LAST_USER_POSITION";

const initialState = {
  isEnable: false,
  city: {},
  contextMenuStyle: {
    position: "absolute",
    zIndex: 1000,
    top: 0,
    left: 0,
    display: "none"
  },
  lastUserPosition: undefined
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_ENABLE_MAP:
      return {
        ...state,
        isEnable: action.value.enable,
        city: action.value.city
      };
    case HANDLE_MENU_CONTEXT_STYLE:
      return {
        ...state,
        contextMenuStyle: {
          ...state.contextMenuStyle,
          display: action.display,
          top: action.top,
          left: action.left
        }
      };
    case UPDATE_LAST_USER_POSITION:
      return { ...state, lastUserPosition: action.value.position };
    default:
      return state;
  }
};

export const changeEnableMap = (enable, city) => dispatch => {
  dispatch({
    type: CHANGE_ENABLE_MAP,
    value: { enable, city }
  });
};

export const handleMenuContextStyle = (display, top, left) => dispatch => {
  dispatch({
    type: HANDLE_MENU_CONTEXT_STYLE,
    display,
    top,
    left
  });
};

export const updateLastUserPosition = position => dispatch => {
  dispatch({
    type: UPDATE_LAST_USER_POSITION,
    value: { position }
  });
};



// WEBPACK FOOTER //
// ./src/modules/map.js